import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { ParametersValueDTO } from '../../types/Process.d';

interface ProcessParametersListProps {
  parameter: ParametersValueDTO;
  newValue: string;
  onChange: (targetValue: string) => void;
}

export default function ProcessesParametersList({
  parameter,
  newValue,
  onChange,
}: ProcessParametersListProps): JSX.Element {
  if (parameter.type === 'boolean') {
    return (
      <FormControl fullWidth>
        <InputLabel>{parameter.abbreviation}</InputLabel>
        <Select
          inputProps={{ 'aria-label': 'Without label' }}
          fullWidth
          label={parameter.abbreviation}
          name={parameter.abbreviation}
          value={newValue}
          onChange={e => {
            if (typeof e.target.value === 'string') {
              onChange(e.target.value);
            }
          }}
        >
          <MenuItem key={`${parameter.id}`} value=''>
            <span style={{ opacity: '0.0' }}>NULL</span>
          </MenuItem>
          <MenuItem key={`${parameter.id}SIM`} value='SIM'>
            SIM
          </MenuItem>
          <MenuItem key={`${parameter.id}NÃO`} value='NAO'>
            NÃO
          </MenuItem>
        </Select>
      </FormControl>
    );
  }
  if (parameter.type === 'string') {
    return (
      <TextField
        label={parameter.abbreviation}
        value={newValue}
        fullWidth
        id={parameter.abbreviation}
        onChange={e => {
          onChange(e.target.value);
        }}
      />
    );
  }
  return (
    <TextField
      label={parameter.abbreviation}
      value={newValue}
      fullWidth
      id={parameter.abbreviation}
      onChange={e => {
        onChange(e.target.value);
      }}
    />
  );
}
